/**
 * ProjectRoleService
 * Service for ProjectRole entity operations
 * Route: api/project-roles
 * Controller: ProjectRoleController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * ProjectRoleService
 * Handles project role CRUD operations
 * Maps to /api/project-roles endpoint
 */
export class ProjectRoleService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? ProjectRoleService.DEFAULT_SERVICE_PATH,
            basePath: ProjectRoleService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
ProjectRoleService.DEFAULT_SERVICE_PATH = 'projects';
ProjectRoleService.BASE_PATH = 'api/project-roles';
//# sourceMappingURL=ProjectRoleService.js.map